export default {
  props: {
    title: String,
    imgUrl: String,
    text: String
  }
};